

/**
 * 根据时间戳获取格式为 (年-月-日)的解析字符串
 * @param stamp 时间戳
 */
export function getShorDateByStamp(timestamp: number) {
    const date = new Date(timestamp);
    // 获取年份、月份、日期、小时、分钟、秒
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，因此需要加1
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * 根据时间戳获取格式为 (年-月-日 时-分-秒)的解析字符串
 * @param stamp 时间戳
 */

export function getDetailDateByStamp(timestamp: number) {
    const date = new Date(timestamp);
    // 获取年份、月份、日期、小时、分钟、秒
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，因此需要加1
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}